import {
  Component,
  ElementRef,
  HostBinding,
  OnInit,
  QueryList, ViewChild,
  ViewChildren
} from '@angular/core';

import { AppServiceService } from "../../../api/app-service.service";
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-under-maintenance',
  templateUrl: './under-maintenance.page.html',
  styleUrls: ['./under-maintenance.page.scss'],

})
export class UnderMaintenancePage implements OnInit {

  logoUrl = environment.BASE_URL + '/images/restaurant-logo/web/';

  constructor(public appService: AppServiceService, public translate: TranslateService, public router: Router) {
  }


  ngOnInit() {
  }

  ngAfterViewInit(){
    this.appService.tryAgainMaintenance();
  }

  refresh() {
    this.router.navigate(['/'], { replaceUrl: true });
  }
}
